import React from 'react';

interface StatusMessageProps {
    visible?: boolean;
    status: any;
    color?: 'red' | 'blue' | 'green' | 'yellow';
    size?: 'sm' | 'md' | 'lg';
    style?: React.CSSProperties;
}

const sizeMap = { sm: '0.875rem', md: '1rem', lg: '1.125rem' };

const StatusMessage: React.FC<StatusMessageProps> = ({
    visible = true,
    status,
    color = 'green',
    size = 'sm',
    style = {},
}) => {
    const text = visible ? status?.message || status : '';

    return (
        <div
            role="status"
            aria-atomic="true"
            style={text ? { ...style, color, fontSize: sizeMap[size] } : undefined}
        >
            {text}
        </div>
    );
};

export default StatusMessage;
